import { useMemo } from "react";

export const useCompetitorsById = <T extends Record<"athleteId", string>>(
    competitors: T[],
) =>
    useMemo(
        () =>
            competitors.reduce(
                (hash, competitor) => {
                    hash[competitor.athleteId] = competitor;
                    return hash;
                },
                {} as Record<string, T>,
            ),
        [competitors],
    );

export const useCompetitorsAndResultsById = <
    T extends Record<"athleteId", string>,
    R extends Record<"athleteId", string>,
>(
    competitors: T[],
    result: R[],
) =>
    useMemo(
        () =>
            competitors.reduce(
                (hash, competitor) => {
                    const matchingResult = result.find(
                        (r) => r.athleteId === competitor.athleteId,
                    );
                    if (!matchingResult) return hash;

                    hash[competitor.athleteId] = {
                        competitor,
                        result: matchingResult,
                    };
                    return hash;
                },
                {} as Record<string, { competitor: T; result: R }>,
            ),
        [competitors, result],
    );
